export const ROLES = {
  superAdmin: "SUPER_ADMIN", //"SUPER_ADMIN",
  admin:"ADMINISTRATOR",
  publisher: "PUBLISHER",
  publisher_user:"PUBLISHER_SUB_USER"
};

export const REGEX = {
  // Email regex pattern
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // we need to take this regex from backend later
  // Phone regex (numbers only)
  PHONE: /^[0-9]*$/,
  // Email regex
  EMAIL_REGEX: /^[a-zA-Z0-9]+([._%+\-]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/,
  // // Regex that accepts only alphabets in both small and capital case
  ONLY_ALPHABETS_REGEX: /^[a-zA-Z ]{2,30}$/,
};

export const DEFAULT_ROUTES = {
  superAdmin: "/admin/dashboard",
  admin:"/admin/dashboard",
  publisher: "/publisher/dashboard",
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const INSERTION_ORDER_STATUS_LABELS = {
  TRUE: "SIGNED",
  FALSE: "UNSIGNED",
};

export const DEFAULT_STATUS_LABELS = {
  active: "ACTIVE",
  inactive: "INACTIVE",
};

export const PRODUCT_TYPE_OPTIONS = [
  { label: "Banner", value: 1 },
  { label: "Instream", value: 2 },
  { label: "Interstitial", value: 3 },
  { label: "Rewarded", value: 4 },
];

export const ROLE_OPTIONS = [
  { label: "Super Admin", value: 1 },
  { label: "Admin", value: 2 },
  { label: "Role 1", value: 3, disabled: true },
  { label: "Role 2", value: 4, disabled: true },
];

export const MAP_ROLE_OPTIONS = [
  // { label: "Super Admin", value: 2 },
  { label: "Admin", value: 1 },
  // { label: "Admin", value: 3 },
];



export const DATE_RANGE_OPTIONS = [
  { label: "Last 1 Month", value: "Last 1 Month" },
  { label: "Last 3 Month", value: "Last 3 Month" },
  { label: "Last 6 Month", value: "Last 6 Month" },
  { label: "Last 12 Month", value: "Last 12 Month" },
  { label: "Custom Range", value: "Custom Range" },
];

export const ADMIN_REPORTING_DATE_RANGE_OPTIONS = [
  { label: "Today", value: "Today" },
  { label: "Yesterday", value: "Yesterday" },
  { label: "Last 7 Days", value: "Last 7 Days" },
  { label: "MTD", value: "MTD" },
  { label: "Last 3 Months", value: "Last 3 Months" },
  { label: "Custom", value: "Custom" },
];

export const VIEW_BY_OPTIONS = [
  { label: "Date", value: "Date" },
  { label: "Publisher", value: "Publisher" },
  { label: "Product", value: "Product" },
  { label: "Deal Name", value: "Deal_Name" },
  { label: "All Filters", value: "All_Filters" },
];

export const STATUS_OPTIONS = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
];

export const DEAL_TAG_STATUS_OPTIONS = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
  { label: "PENDING", value: "PENDING" },
];

export const CSV_STATUS_OPTIONS = [
  { label: "Pending", value: "PENDING" },
  { label: "In Progress", value: "IN-PROGRESS" },
  { label: "Processed", value: "PROCESSED" },
];

export const INSERTION_ORDERS_STATUS_OPTIONS = [
  { label: "SIGNED", value: "SIGNED" },
  { label: "UNSIGNED", value: "UNSIGNED" },
];

export const PUBLISHER_OPTIONS = [
  { value: 1, label: "publisher1" },
  { value: 2, label: "publisher2" },
  { value: 3, label: "publisher3" },
  { value: 4, label: "publisher4" },
  { value: 5, label: "publisher5" },
  { value: 6, label: "publisher6" },
  { value: 7, label: "publisher7" },
  { value: 8, label: "publisher8" },
  { value: 9, label: "publisher9" },
  { value: 10, label: "publisher10" },
];

export const SELECT_CUSTOM_STYLES = {
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "47px",
    fontSize: "0.875rem",
    borderColor: state.selectProps.className?.includes("is-invalid")
      ? COLOR_HEX.INVALID_INPUT_BORDER
      : state.isFocused
        ? COLOR_HEX.VALID_INPUT_BORDER
        : COLOR_HEX.VALID_INPUT_BORDER,
    boxShadow: state.isFocused ? "0 0 0 1px #DEE2E6" : "none",
    "&:hover": {
      borderColor: state.selectProps.className?.includes("is-invalid")
        ? COLOR_HEX.INVALID_INPUT_BORDER
        : COLOR_HEX.VALID_INPUT_BORDER,
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 18px",
    fontSize: "0.7500000025rem",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "33px",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.875rem",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "15rem",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: COLOR_HEX.SELECT_INPUT_COLOR,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: COLOR_HEX.SELECT_PLACEHOLDER_COLOR,
  }),
};

export const COLOR_HEX = {
  INVALID_INPUT_BORDER: "#FB6E40", // // red color for invalid input border
  VALID_INPUT_BORDER: "#DEE2E6", // // select input and placeholder color
  SELECT_PLACEHOLDER_COLOR: "#ADB5BD", // // select input and placeholder color
};
